import { Layout, Code2, Palette, BarChart3, ShieldCheck, Rocket } from "lucide-react";
import ServiceCard from "../Cards/ServiceCard";
import { motion } from "framer-motion";

const SERVICES = [
  {
    title: "Branding & Creativity",
    description:
      "We craft strong brand identities through visual design, messaging, and creative direction that help businesses stand out and connect with their audience.",
    icon: Palette,
  },
  {
    title: "Web Development",
    description:
      "We build fast, responsive, and scalable websites and web applications tailored to your business goals using modern technologies.",
    icon: Code2,
  },
  {
    title: "S.E.O (Search Engine Optimization)",
    description:
      "We optimize your digital presence to improve search rankings, increase organic traffic, and attract the right audience to your business.",
    icon: ShieldCheck,
  },
  {
    title: "Product Strategy",
    description:
      "From idea validation to execution, we help define clear product strategies that align user needs with long-term business growth.",
    icon: BarChart3,
  },
  {
    title: "Paid Advertising (Performance Marketing)",
    description:
      "We design and manage data-driven advertising campaigns that maximize reach, conversions, and return on investment across platforms.",
    icon: Layout,
  },
  {
    title: "Social Media Marketing",
    description:
      "We create and manage engaging social media strategies that build brand awareness, drive engagement, and grow your online community.",
    icon: Rocket,
  },
  {
    title: "Video & Media Production",
    description:
      "We produce high-quality video and media content that tells your brand story, captures attention, and boosts digital engagement.",
    icon: Rocket,
  },
];


export default function Services() {
  return (
    <section
      id="services"
      className="py-28 max-w-7xl mx-auto px-6"
    >
      {/* Section Header */}
      <motion.div
  initial={{ opacity: 0, y: 20 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true }}
>
  <div className="relative text-center max-w-3xl mx-auto mb-24">
  {/* subtle accent line */}
  <div className="mx-auto mb-6 h-[2px] w-16 bg-gradient-to-r from-blue-500 via-cyan-400 to-indigo-500 rounded-full" />

  <h2 className="text-4xl md:text-3xl font-extrabold tracking-tight mb-6
    text-[#0A0F1C] dark:text-white">
    What We Do at{" "}
    <span
      className="bg-gradient-to-r from-blue-600 via-cyan-500 to-indigo-600
      bg-clip-text text-transparent"
    >
      360Support
    </span>
  </h2>

  <p className="text-lg leading-relaxed text-slate-600 dark:text-slate-200">
    We deliver end-to-end digital solutions focused on clarity, performance,
    and long-term business growth.
  </p>

  {/* soft background glow */}
  <div className="absolute -top-10 left-1/2 -translate-x-1/2 -z-10
    w-72 h-72 rounded-full bg-blue-500/10 blur-3xl" />
</div>

</motion.div>


      {/* Services Grid */}
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((service) => (
          <ServiceCard
            key={service.title}
            title={service.title}
            description={service.description}
            icon={service.icon}
          />
        ))}
      </div>
    </section>
  );
}
